import {CSSProperties, FC, ReactNode, useCallback} from 'react'
import {useSelector} from 'react-redux'
import {useThemeMode} from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import clsx from 'clsx'
import { Color } from '../Constants/colors.constants'

type Props = {
  classNameContainer?: string
  handleClick?: Function
  checked?: boolean
  data?: any
  styleInactive?: CSSProperties
  styleActive?: CSSProperties
  classNameCheckedInactive?: string
  classNameCheckedActive?: string
  label?: ReactNode
  classNameDefaultLabel?: string
}
export const RadioButton: FC<Props> = ({
  checked,
  handleClick,
  data,
  classNameContainer = 'd-flex align-items-center cursor-pointer',
  styleInactive = {
    border: '1px solid #e74c3c',
    borderRadius: 100,
    minWidth: 20,
    minHeight: 20,
  },
  styleActive = {
    border: '6px solid #e74c3c',
  },
  label = '',
  classNameCheckedActive = 'fw-bolder text-black',
  classNameCheckedInactive = 'text-gray-500',
  classNameDefaultLabel = 'me-3 fw-bold'
}) => {
  const {mode} = useThemeMode()
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const handleCheck = useCallback(() => {
    if (Submitted) return
    if (handleClick) {
      if(!data){
         handleClick()
         return
      }  
      handleClick(data)
    }
  }, [Submitted, data, handleClick])
  const styles = {
    borderRadius: 100,
    width: 20,
    height: 20,
    ...(checked
      ? {
        borderWidth: '6px',
        borderStyle: 'solid',
        borderColor: mode === "dark" ? Color.BG_DARK : Color.BG_LIGHT
      }
      :
      {
        border: '1px solid gray',
      }
    ),
    ...{
      cursor: Submitted ? 'not-allowed' : 'pointer'
    }
  }
  return (
    <div data-bs-theme={mode} className={classNameContainer} onClick={handleCheck}>
      <div className='me-2 bg-light' style={styles} />
      {label && (
        <div
          className={clsx([classNameDefaultLabel], {
            [classNameCheckedActive]: checked,
            [classNameCheckedInactive]: !checked,
            'text-white': mode === "dark"
          })}
        >
          {label}
        </div>
      )}
    </div>
  )
}
